import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { userInfoQueryOptions } from "@/lib/queries/userInfo";
import { useBuyPlan } from "@/lib/mutations/plan";

export function useRedirectBack() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { code, redirect, redirectSearch, buyPlanId, buyPlanCoupon } =
    useSearch({
      from: "/auth",
    });

  const buyPlan = useBuyPlan({
    id: buyPlanId ?? "",
    period: "yearly",
    coupon: buyPlanCoupon,
  });

  return (additionalSearchParams?: Record<string, any>) => {
    const mergedSearch = {
      ...(redirectSearch || {}),
      ...(additionalSearchParams || {}),
    };

    queryClient.clear();
    queryClient
      .refetchQueries({
        queryKey: userInfoQueryOptions.queryKey,
      })
      .catch(() => console.error)
      .then(async () => {
        if (buyPlanId) {
          const data = await buyPlan.mutateAsync();
          // just in case
          window.location.href = data.checkout_url;
          throw null as never;
        }
        if (code !== undefined)
          navigate({
            to: "/ai-detector",
            search: {
              appSumoGreeting: true,
              ...mergedSearch,
            },
          });
        else
          navigate({
            to: redirect ?? "/",
            search: mergedSearch,
          });
      });
  };
}

const REFERRAL_CODE_STORAGE_KEY = "referral_code";
export function saveReferralCode(referral: string) {
  sessionStorage.setItem(REFERRAL_CODE_STORAGE_KEY, referral);
}
export function getReferralCode(): string | null {
  return sessionStorage.getItem(REFERRAL_CODE_STORAGE_KEY);
}
